<template>
  <v-dialog
    :value="editingPassword"
    @click:outside="closeDialog"
    max-width="500"
  >
    <v-card>
      <v-form
        @submit.prevent="updatePassword"
        v-model="valid"
        ref="passwordForm"
      >
        <v-card-title>
          Edit Password
          <v-spacer />
          <v-tooltip bottom nudge-left="40px" nudge-top="20px">
            <template v-slot:activator="{ on }">
              <v-checkbox
                class="ma-0 pa-0"
                v-model="showPassword"
                on-icon="mdi-eye"
                off-icon="mdi-eye-off"
                v-on="on"
              ></v-checkbox>
            </template>
            <span>{{ showPassword ? 'Hide Password' : 'Show Password' }}</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-alert type="error" dense dismissible v-if="showError">{{
            errorMessage
          }}</v-alert>
          <p class="overline mb-2">Current Password</p>
          <v-text-field
            outlined
            dense
            :type="showPassword ? 'text' : 'password'"
            :rules="[rules.required, rules.password]"
            v-model="currentPassword"
          ></v-text-field>
          <p class="overline mb-2">New Password</p>
          <v-text-field
            outlined
            dense
            :type="showPassword ? 'text' : 'password'"
            :rules="[
              rules.required,
              rules.password,
              rules.newPassword(newPassword, currentPassword),
            ]"
            v-model="newPassword"
          ></v-text-field>
          <p class="overline mb-2">Confirm</p>
          <v-text-field
            outlined
            dense
            :type="showPassword ? 'text' : 'password'"
            :rules="[
              rules.confirmPassword(newPassword, confirmPassword),
              rules.required,
            ]"
            v-model="confirmPassword"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeDialog" color="error">Close</v-btn>
          <v-btn type="submit" color="info" @click="validate">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChangePasswordDialog',
  props: {
    editingPassword: {
      type: Boolean,
    },
    showError: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
  },
  data: () => ({
    valid: false,
    currentPassword: null,
    newPassword: null,
    confirmPassword: null,
    showPassword: false,
    rules: {
      required: (value) => !!value || 'Required.',
      password: (value) => {
        const pattern = /.{6,}/gm
        return pattern.test(value) || 'Must be a least 6 characters'
      },
      confirmPassword: (ps1, ps2) => ps1 === ps2 || "Passwords don't match",
      newPassword: (newPs, oldPs) =>
        newPs !== oldPs || 'Must be a different password',
    },
  }),
  methods: {
    updatePassword() {
      if (this.valid) {
        this.$emit('updatePassword', {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        })
      }
    },
    closeDialog() {
      this.reset()
      this.$emit('onDialogClosed')
    },
    validate() {
      this.$refs.passwordForm.validate()
    },
    reset() {
      this.$refs.passwordForm.reset()
    },
  },
}
</script>

<style scoped></style>
